<template>
  <div class="courseRecord">
    <div class="courseRecord_top">
      <el-cascader
        :options="classList"
        :show-all-levels="false"
        :props="classProp"
        clearable
        placeholder="请选择班级"
        v-model="courseParams.classid"
        @change="GetCouseStudyRecord"
      ></el-cascader>
      <el-date-picker
        style="margin-left: 20px"
        v-model="selectDate"
        type="datetimerange"
        @change="dateChange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
    </div>
    <div class="courseRecord_body">
      <el-table
        :data="courseTableData"
        stripe
        tooltip-effect="dark"
        style="width: 100%"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>

        <el-table-column
          prop="username"
          label="姓名"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="usercode"
          label="学号"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="classname"
          label="班级名称"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="videotime" label="视频时长" align="center">
        </el-table-column>
        <el-table-column
          prop="coursename"
          label="课程名称"
          align="center"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="studyprogress" label="学习进度" align="center">
        </el-table-column>
        <el-table-column prop="usedtime" label="学习时长" align="center">
        </el-table-column>
        <el-table-column prop="studycount" label="学习次数" align="center">
        </el-table-column>
        <el-table-column
          sortable
          prop="createdate"
          label="创建时间"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          style="text-align: center; margin-top: 20px"
          :hide-on-single-page="true"
          :total="total"
          :page-size="courseParams.pagesize"
          :current-page.sync="courseParams.pageindex"
          @current-change="GetCouseStudyRecord"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../../api/index";

export default {
  data() {
    return {
      classList: [],
      classProp: {
        label: "orgname",
        value: "orgid",
        children: "children",
        expandTrigger: "hover",
        emitPath: false,
      },
      total: 0,
      selectDate: "",
      courseParams: {
        classid: "",
        courseid: "",
        startdate: "",
        enddate: "",
        pageindex: 1,
        pagesize: 13,
      },
      courseTableData: [],
    };
  },
  created() {
    this.GetUserSpecClassData();
    this.GetCouseStudyRecord();
  },
  methods: {
    //时间转换
    formatSeconds(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s = Math.floor(result % 60);

      let res = "";
      if (h !== "00") res += `${h}时`;
      if (m !== "00") res += `${m}分`;
      res += `${s}秒`;
      return res;
    },
    //获取班级列表
    async GetUserSpecClassData() {
      const res = await Api.userinfo.GetUserSpecClassData();
      this.classList = res.rows.orglist;
    },
    dateChange(e) {
      this.courseParams.startdate = e != null ? e[0] : "";
      this.courseParams.enddate = e != null ? e[1] : "";
      this.GetCouseStudyRecord();
    },
    //学习课程记录
    async GetCouseStudyRecord() {
      const res = await Api.sum.GetCouseStudyRecord(this.courseParams);
      if (res.success != true) return this.$message.info(res.msg);
      this.total = res.total;
      console.log(res);
      this.courseTableData = res.rows;
      for (let i = 0; i < this.courseTableData.length; i++) {
        const element = this.courseTableData[i];
        element.studyprogress = Math.round(element.studyprogress * 100) + "%";
        element.videotime = this.formatSeconds(element.videotime);
        element.usedtime = this.formatSeconds(element.usedtime);
      }
    },
  },
};
</script>
<style lang='less' scoped>
.courseRecord {
  width: 100%;
  height: 100%;
  background: #fff;
  .courseRecord_top {
    padding: 15px;
  }
}
</style>